import { useMemo } from "react";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellText from "ds/components/Table/Row/CellText";
import { ConfigElement } from "types/generated";

import useCellCopyAction from "../../useCellCopyAction";

const IntentProjectEnvironmentVariablesTableIdCell = ({
  item: variable,
  ...cellProps
}: TableSimpleCellProps<ConfigElement>) => {
  const copyAction = useCellCopyAction({
    text: variable.id,
  });

  const actions = useMemo(() => [copyAction], [copyAction]);

  return (
    <TableSimpleCell {...cellProps} role="rowheader" actions={actions}>
      <TableCellText>{variable.id}</TableCellText>
    </TableSimpleCell>
  );
};

export default IntentProjectEnvironmentVariablesTableIdCell;
